import React from 'react';
import PropTypes from 'prop-types';
import Styled, {keyframes} from 'styled-components';

const anim = keyframes`{
    0%{background-position:100% 0%}
    50%{background-position:0% 100%}
    100%{background-position:100% 0%}
}

`;

const Sizer = Styled.div`
    width: ${({width}) => (width ? `${width}px` : '100%;')};
    height: ${({height}) => (height ? `${height}px` : '100%;')};
    background-color: #F7F8FB;
    border-radius: 2px;
`;

const AnimatedSizer = Styled(Sizer)`
    background: linear-gradient(270deg, #f3f3f3, #e1e1e1, #f3f3f3);
    background-size: 200% 200%;
    animation: ${anim} 2.5s ease infinite;
    
`;
export const Placeholder = ({width, height, animate}) => {
	return animate ? <AnimatedSizer height={height} width={width} /> : <Sizer height={height} width={width} />;
};

Placeholder.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	animate: PropTypes.bool,
};

Placeholder.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
	animate: PropTypes.bool,
};
